const ReviewStars = ({ rating = 50 }) => {
  return (
    <div className="relative inline-flex"> 
      <div className="flex items-center text-neutral-200 text-2xl overflow-hidden">
        {[...Array(5)].map((_, index) => (
          <i key={index} className="fa-sharp fa-solid fa-fw fa-star flex-shrink-0"></i>
        ))}
      </div> 

      <div className="absolute top-0 left-0 overflow-hidden flex items-center text-chestnut-rose text-2xl"  style={{ width: `${rating}%` }}>
        {[...Array(5)].map((_, index) => (
          <i key={index} className="fa-sharp fa-solid fa-fw fa-star flex-shrink-0"></i>
        ))}
      </div>
    </div>
  );
};

export default ReviewStars;
